type P = { [key: string]: any };

const removeDuplicates = <T extends P>(arr: T[], key: string): T[] => [
  ...new Map(arr.map(item => [item[key], item])).values()
];

export default removeDuplicates;
